import PropTypes from "prop-types";

import ActionButton from "./ActionButton";
import T from "./translations/Translations";

import { formatLongDate, getEpoch, getTodayWithTime } from "../utils/DateFormatter";

/**
 * Display a select list of available quarters
 * @param {[]} activeQuarters
 * @param {string} selectedQuarter
 * @param {func} setSelectedQuarter
 * @returns {JSX.Element}
 */
const QuarterSelect = ({ activeQuarters, resetSearch, selectedQuarter, setSelectedQuarter }) => {
    const getQuarterLabel = (quarterName) => {
        return (
            <>
                <div>{quarterName.substr(-2)}</div>
                <div style={{ fontSize: "0.7rem", marginTop: "-6px" }}>
                    {`${T({ key: "Quarter_View" })} ${quarterName.substr(-2)}`}
                </div>
            </>
        );
    };

    return (
        <div className="quarter-container">
            {T({ key: "Quarter_Instruction" })}
            <div className="quarter-button-container">
                {activeQuarters.map((quarter, index) => {
                    const { quarterEndDate, quarterName, quarterStartDate } = quarter;
                    let buttonDisable = false;
                    if (getEpoch(quarterStartDate) >= getEpoch(getTodayWithTime())) {
                        buttonDisable = true;
                    }
                    const myClass = selectedQuarter === quarterName ? "action-button-selected" : "";
                    return (
                        <div className="quarter-button" key={`quarter-option-${quarter}-${index}`}>
                            <ActionButton
                                className={`action-button-quarter ${myClass}`}
                                disable={buttonDisable}
                                id={`quarter-button-${index}`}
                                label={getQuarterLabel(quarterName)}
                                name={`quarter-button-${index}`}
                                onClick={() => {
                                    resetSearch(true);
                                    setSelectedQuarter(quarterName);
                                }}
                                value={quarterName}
                            />
                            <div className="start-end-dates">
                                {formatLongDate(quarterStartDate)} - {formatLongDate(quarterEndDate)}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

QuarterSelect.propTypes = {
    activeQuarters: PropTypes.instanceOf(Array).isRequired,
    resetSearch: PropTypes.func.isRequired,
    selectedQuarter: PropTypes.string,
    setSelectedQuarter: PropTypes.func.isRequired
};

QuarterSelect.defaultProps = {
    selectedQuarter: null
};

export default QuarterSelect;
